document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-rt-add-btn]');
  if (!btn) return;

  var variantId = btn.getAttribute('data-variant-id');
  var label = btn.querySelector('[data-rt-btn-label]');
  var originalText = label ? label.textContent : btn.textContent;

  if (btn.disabled) return;
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }]
    })
  })
    .then(function (response) {
      if (!response.ok) throw new Error('No se pudo añadir el producto');
      return response.json();
    })
    .then(function () {
      if (label) {
        label.textContent = 'Añadido ✓';
      } else {
        btn.textContent = 'Añadido ✓';
      }
      btn.classList.add('rt-card__add--added');

      // Refresca el contador del carrito del tema.
      // AJUSTA ESTO si el tema ya expone su propio helper (revisa cart-drawer.js /
      // theme.js del tema Reformation) — así el mini-carrito se abre solo en vez
      // de quedarse solo actualizando el número.
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

          var bubble = document.querySelector('[data-cart-count], .cart-count-bubble, .cart-count');
          if (bubble) bubble.textContent = cart.item_count;
        });

      setTimeout(function () {
        if (label) {
          label.textContent = originalText;
        } else {
          btn.textContent = originalText;
        }
        btn.classList.remove('rt-card__add--added');
        btn.disabled = false;
      }, 1800);
    })
    .catch(function () {
      if (label) label.textContent = 'Error, reintenta';
      btn.disabled = false;
    });
});